import { render, staticRenderFns } from "./Cosechas.vue?vue&type=template&id=b76db6f4"
import script from "./Cosechas.vue?vue&type=script&lang=js"
export * from "./Cosechas.vue?vue&type=script&lang=js"
import style0 from "./Cosechas.vue?vue&type=style&index=0&id=b76db6f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports